module.exports = __webpack_public_path__ + "static/fonts/NeoSansPro-Italic.e5e9701.eot";